var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-table-column',{attrs:{"prop":_vm.prop,"label":_vm.label,"width":_vm.width,"min-width":_vm.minWidth,"align":_vm.tableRender.align || _vm.align,"class-name":_vm.className},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" "+_vm._s(_vm.getValue(scope.row))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }